//cores
import {Component, OnInit, ViewChild} from '@angular/core';
import {Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';

//models
import {SlxAdminCustomerModel} from './model/slx-admin-customer.model';
import {CustomerFilterModel} from './model/customer-filter.model';

// services
import {SlxAdminCustomersService} from './service/slx-admin-customers.service';
import {SearchAndPaginationService} from '../shared/services/search-and-pagination.service';

// responsiveness
import {MediaObserver} from '@angular/flex-layout';

// components
import {PaginationComponent} from '../shared/pagination/pagination.component';

// constants
import {AppConstants} from '../utils/constants';
import {CustomerService} from "../customer/services/customer-service.service";
import {LangChangeEvent, TranslateService} from '@ngx-translate/core';
import {UtilsService} from '../utils/utils.service';
import {HttpParams} from "@angular/common/http";

@Component({
    selector: 'app-slx-admin-manage-customers',
    templateUrl: './slx-admin-manage-customers.component.html',
    styleUrls: ['./slx-admin-manage-customers.component.scss'],
    standalone: false
})
export class SlxAdminManageCustomersComponent implements OnInit {

  @ViewChild(PaginationComponent, { static: true }) private paginationComponent: PaginationComponent;

  public selectedStatus = AppConstants.all;
  public selectedTargetGroup = AppConstants.all;
  public selectedConfirmed = AppConstants.all;
  public selectedCountry = AppConstants.all;

  private listOfCustomers: Array<SlxAdminCustomerModel> = new Array<SlxAdminCustomerModel>();
  private customerFilter = new CustomerFilterModel();
  private searchForm: UntypedFormGroup;
  private mobileSearchOpen: boolean;
  private totalNumberOfItems: number;

  private targetGroupValueFilter: any = null;
  private activeValueFilter: any;
  private countryCodeValueFilter: any = null;
  private confirmationValueFilter: any = null;

  private loading = false;

  private homePath = AppConstants.homePage;

  private activeStates: Array<any> = new Array<any>();
  private targetGroups: Array<any> = new Array<any>();
  private countryCodes: Array<any> = new Array<any>();
  private assignedCountries: Array<any> = new Array<any>();
  private confirmationStates: Array<any> = new Array<any>();

  public sortingObj = {
    sortCustomerNumberField: {
      self: 'sortCustomerNumberField',
      field: AppConstants.sortCustomerNumberField,
      direction: '',
      sorting: undefined
    },
    sortCompanyField: {
      self: 'sortCompanyField',
      field: AppConstants.sortCompanyField,
      direction: '',
      sorting: undefined
    },
    sortStatusField: {
      self: 'sortStatusField',
      field: AppConstants.sortStatusField,
      direction: '',
      sorting: undefined
    },
    sortConfirmedField: {
      self: 'sortConfirmedField',
      field: AppConstants.sortConfirmedField,
      direction: '',
      sorting: undefined
    },
    sortCountryCodeField: {
      self: 'sortCountryCodeField',
      field: AppConstants.sortCountryCodeField,
      direction: '',
      sorting: undefined
    },
  };

  private sortField = null;
  private sortDirection = null;
  private customerNumber: string;

  constructor(private _adminService: SlxAdminCustomersService,
              private _router: Router,
              private _formBuilder: UntypedFormBuilder,
              public _observableMedia: MediaObserver,
              private _customerService: CustomerService,
              private _searchAndPaginationService: SearchAndPaginationService,
              private _utilsService: UtilsService,
              private _translateService: TranslateService) {
    this.searchForm = _formBuilder.group({
      searchTerm: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ],
      status: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ],
      targetGroup: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ],
      confirmation: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ],
      countryCode: [
        {
          value: '',
          disabled: false
        },
        Validators.required
      ]
    });

    _translateService.onLangChange.subscribe((event: LangChangeEvent) => {
      this.activeStates = this._utilsService.initializeSelectOrMultiselect([AppConstants.all, AppConstants.active, AppConstants.notActive]);
      this.targetGroups = this._utilsService.initializeSelectOrMultiselect(AppConstants.targetGroupsArray);
      this.confirmationStates = this._utilsService.initializeSelectOrMultiselect([AppConstants.all, AppConstants.confirmed, AppConstants.unconfirmed]);
    });


    this.activeStates = this._utilsService.initializeSelectOrMultiselect([AppConstants.all, AppConstants.active, AppConstants.notActive]);
    this.targetGroups = this._utilsService.initializeSelectOrMultiselect(AppConstants.targetGroupsArray);
    this.confirmationStates = this._utilsService.initializeSelectOrMultiselect([AppConstants.all, AppConstants.confirmed, AppConstants.unconfirmed]);
    this.getAssignedCountries();
  }


  ngOnInit() {
    this._searchAndPaginationService.setOffset(0);
    this.submitRequest();
  }

  public getListOfCustomers() {
    return this.listOfCustomers;
  }

  public getItemsPerPage() {
    return this._searchAndPaginationService.getItemsPerPage();
  }

  public getSearchForm() {
    return this.searchForm;
  }

  public getMobileSearchOpen() {
    return this.mobileSearchOpen;
  }

  public getTotalNumberOfItems() {
    return this.totalNumberOfItems;
  }

  public getLoading() {
    return this.loading;
  }

  public getHomePath() {
    return this.homePath;
  }

  public getActiveStates() {
    return this.activeStates;
  }

  public getTargetGroups() {
    return this.targetGroups;
  }

  public getCountryCode() {
    return this.countryCodes;
  }

  public getConfirmationStates() {
      return this.confirmationStates;
    }

  onSelectStatus(option) {
    this.activeValueFilter = this._utilsService.getBoolVal(option.value);
    this.submitRequest();
  }

  onSelectTGroup(option) {
    this.targetGroupValueFilter = this._utilsService.getBoolVal(option.value);
    this.submitRequest();
  }

  onSelectCountryCode(option) {
    this.countryCodeValueFilter = this._utilsService.getBoolVal(option.value);
    this.submitRequest();
  }

  onSelectConfirmation(option) {
      this.confirmationValueFilter = this._utilsService.getBoolVal(option.value);
      this.submitRequest();
    }

  public goToNewCustomerPage() {
    this._router.navigate(['/' + AppConstants.createCustomer], {queryParams: {type: 'create'}});
  }

  public goToEditCustomer(customer: SlxAdminCustomerModel) {
    this.loading = true;
    this._customerService.getCustomerByCustomerNumber(customer.customerNumber).subscribe(res => {
      this.loading = false;
      this._router.navigate(['/' + AppConstants.editCustomer, customer.customerNumber], {queryParams: {type: 'edit'}});
    }, (error) => {
      this.loading = false;
    })
  }

  /**
   * @description Get all customers that match the searching term
   */
  submitRequest() {
    this.loading = true;

    if (this._searchAndPaginationService.searchKeyWordNotEquals(this.searchForm.controls['searchTerm'].value)) {
      this._searchAndPaginationService.setSearchKeyWord(this.searchForm.controls['searchTerm'].value);
    }
    this.searchForm.controls.searchTerm.setValue(this._searchAndPaginationService.getSearchKeyWord());

    const searchParams: HttpParams = this.createSearchParams();

    this._adminService.searchCustomers(searchParams).subscribe(
      (res) => {
        this.loading = false;
        const response: any = res;
        this.listOfCustomers = response.data;
        this._searchAndPaginationService.setItemsPerPage(response.itemsPerPage);
        this.totalNumberOfItems = response.itemsTotal;
        this.paginationComponent.setCurrentPageValue(Math.ceil(response.offset / response.itemsPerPage + 1));
      }, (error) => {
        this.loading = false;
      });
  }

  getAssignedCountries(){
      this.loading = true;
      this._adminService.loadAssignedCountries().subscribe(
        (res) => {
        this.loading = false;
          const response: any = res;
          this.mapCountries(res);
          this.countryCodes = this._utilsService.initializeSelectOrMultiselect(this.assignedCountries);

          // place "all" first in array
          const indexAll = this.countryCodes.findIndex((element) => element.value === "All");
          if(indexAll !== -1 && indexAll !== 0) {
              var element = this.countryCodes[indexAll];
              this.countryCodes.splice(indexAll,1);
              this.countryCodes.unshift(element);
          }

        }, (error) => {
          this.loading = false;
        });
    }

    mapCountries(res){
      for(var i = 0; i < res.length; i++){
      this.assignedCountries.push("country." + res[i]);
      }
       this.assignedCountries.sort();
       this.assignedCountries.unshift(AppConstants.all)
      }

  /**
   * @description Clears the search input field and all projects will be be fetched
   */
  clearInputField() {
    //this.searchForm.reset();
    this.searchForm.controls['searchTerm'].reset();
    this._searchAndPaginationService.setSearchKeyWord('');
    this.submitRequest();
  }

  /**
   * @description Opens search input on mobile devices
   */
  openMobileSearch() {
    if (this._observableMedia.isActive('gt-sm')) {
      return;
    }
    this.mobileSearchOpen = true;
  }

  /**
   * @description Hides search input on mobile devices and clears the input
   */
  clearInputFieldAndCloseMobileSearch() {
    this.clearInputField();
    this.mobileSearchOpen = false;
  }

  public onPageSizeChange(pageSize: number) {
    this._searchAndPaginationService.setItemsPerPage(pageSize);
    this.submitRequest();
  }

  public onPageChange(page: number) {
    this._searchAndPaginationService.setOffset(this.getItemsPerPage() * (page - 1));
    this.submitRequest();
  }

  private createSearchParams(): HttpParams {
    let searchParams = new HttpParams();
    if(this._searchAndPaginationService.getSearchKeyWord() != null) {
      searchParams = searchParams.set("searchTerm", this._searchAndPaginationService.getSearchKeyWord());
    }
    if(this.activeValueFilter != null) {
      searchParams = searchParams.set("active", this.activeValueFilter);
    }
    if(this.confirmationValueFilter != null) {
      searchParams = searchParams.set("confirmed", this.confirmationValueFilter);
    }
    if(this.targetGroupValueFilter != null) {
      searchParams = searchParams.set("targetGroup", this.targetGroupValueFilter);
    }
    if(this.countryCodeValueFilter != null) {
      searchParams = searchParams.set("country", this.countryCodeValueFilter);
    }
    if(this.sortField != null) {
      searchParams = searchParams.set("field", this.sortField);
    }
    if(this.sortDirection != null) {
      searchParams = searchParams.set("order", this.sortDirection);
    }
    if(this._searchAndPaginationService.getOffset() != null) {
      searchParams = searchParams.set("offset", this._searchAndPaginationService.getOffset());
    }
    if(this._searchAndPaginationService.getItemsPerPage() != null) {
      searchParams = searchParams.set("pageSize", this._searchAndPaginationService.getItemsPerPage());
    }
    return searchParams;
  }

  public sortTable(el) {
    for (const key in this.sortingObj) {
      if (el.self == key) {
        this.sortingObj[key].sorting = !this.sortingObj[key].sorting;
        if (this.sortingObj[key].sorting) {
          this.sortingObj[key].direction = 'ASC';
        } else {
          this.sortingObj[key].direction = 'DESC';
        }
        this.sortField = el.field;
        this.sortDirection = el.direction;
      } else {
        this.sortingObj[key].sorting = undefined;
      }
    }
    this.submitRequest();
  }
}
